module.exports = __webpack_public_path__ + "static/IMFellEnglish-Regular-74dd8478d56ad25f51e778157d37bf67.ttf";